const OPTIONS: Intl.DateTimeFormatOptions = {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
};

/**
 * Takes a date string that represents a UTC date and time
 * Returns a formatted version of the user's local date
 *
 * @param utcDateString - supports various formats. ex: "2024-07-11 15:15:58.875000", "2024-07-11T15:15:58.875000Z", "2024-07-11 14:51:28.078000+00:00", "2024-07-11 05:51:28.078000+00:00"
 * @param numHoursToAdd - optional number of hours to add to the date before formatting
 * @returns formatted date string in the user's local timezone. ex: "7/11/24", "7/11/24", "7/11/24", "7/10/24" (previous day locally)
 */
export function formatUtcToLocalDate(utcDateString?: string, numHoursToAdd?: number): string {
    if (!utcDateString) {
        return 'N/A';
    }

    // Remove any characters after the timezone offset
    const cleanUtcDateString = utcDateString.split('+')[0].trim();

    // Ensure the date is parsed as UTC
    const utcDate = cleanUtcDateString.includes('T')
        ? new Date(cleanUtcDateString)
        : new Date(`${cleanUtcDateString.replace(' ', 'T')}Z`);

    // Add hours if necessary
    if (numHoursToAdd) {
        utcDate.setHours(utcDate.getHours() + numHoursToAdd);
    }

    return utcDate.toLocaleDateString(undefined, OPTIONS);
}
